'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const defaultIntlLocale = 'en-US';
/**
 * Base datetime formatter function that others should call
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * @param dateTime Date | string
 * @param locale string | string[]
 * @param options Intl.DateTimeFormatOptions | undefined
 * @returns string
 */ const formatDateTime = (dateTime, locale, options)=>{
    const locales = Array.isArray(locale) ? [
        ...locale,
        defaultIntlLocale
    ] : [
        locale,
        defaultIntlLocale
    ];
    return new Intl.DateTimeFormat(locales, options).format(new Date(dateTime));
};

exports.formatDateTime = formatDateTime;
//# sourceMappingURL=format.js.map
